import { Directive } from '@angular/core';

@Directive({
  selector: '[uiBottomSheetFooter]',
  standalone: false,
})
export class UiBottomSheetFooterDirective {}
